import Vue from "vue";

import {
    ICheckoutModel, IOrderModel, IPromotionModel, ISettingsModel, IValidationRules
} from "../../models";
import AppMutationTypes from "./AppMutationTypes";
import IAppMutationTree from "./IAppMutationTree";

const mutations: IAppMutationTree = {
    setSettings(state, payload: ISettingsModel) {
        state.paymentMethods = payload.paymentMethods || [];
        state.genericOrderFailedMessage = payload.genericOrderFailedMessage;
    },

    setValidationRules(state, payload: IValidationRules) {
        // this makes the previously unset property reactive.
        // see https://vuex.vuejs.org/guide/mutations.html#mutations-follow-vue-s-reactivity-rules
        Vue.set(state, "validationRules", payload);
    },

    setPromotion(state, payload: IPromotionModel) {
        Vue.set(state, "promotion", payload);
    },

    setCheckout(state, payload: ICheckoutModel) {
        Vue.set(state, "checkout", payload);
    },

    setOrder(state, payload: IOrderModel) {
        Vue.set(state, "order", payload);
    },

    setDocumentTitleAndColor(state, payload: IPromotionModel) {
        if (payload.name) {
            state.pageTitle = payload.name;
            document.title = payload.name || "";
        }

        if (payload.backgroundColor) {
            document.body.style.backgroundColor = payload.backgroundColor;
        }
    }
};

export default mutations;

export { AppMutationTypes };
